import type { DropdownDto, GetCrmPhoneDetailDto, SignDocumentEmailDto } from './models';
import { RestService, Rest } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import type { CarrierCachingDto } from '../../coredata-service/carrier/models';
import type { EntityIdAndEntityTypeDto } from '../../coredata-service/common-service/models';
import type { ProjectType } from '../../coredata-service/enums/project-type.enum';
import type { PageMasterDTO } from '../../coredata-service/page-masters/models';
import type { DropDownDto } from '../../coredata-service/verified-from-emails/models';
import type { DropdownType } from '../enums/dropdown-type.enum';

@Injectable({
  providedIn: 'root',
})
export class CommonService {
  apiName = 'Default';
  

  checkAgencyORAgencyStaff = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, boolean>({
      method: 'POST',
      url: '/api/crm-service/common/check-agency-oRAgency-staff',
    },
    { apiName: this.apiName,...config });
  

  downloadFileByDocumentName = (DocumentName: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, number[]>({
      method: 'POST',
      url: '/api/crm-service/common/download-file',
      params: { documentName: DocumentName },
    },
    { apiName: this.apiName,...config });
  

  fromEmailAddressDropDown = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, DropDownDto[]>({
      method: 'POST',
      url: '/api/crm-service/common/from-email-address-drop-down',
    },
    { apiName: this.apiName,...config });
  

  getAgencyIdByCurrentAgency = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, number>({
      method: 'GET',
      url: '/api/crm-service/common/agency-id-by-current-agency',
    },
    { apiName: this.apiName,...config });
  

  getAgencyStaffUserIdByAgencyIdAndTenantId = (AgencyId: number, TenantId: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, string[]>({
      method: 'GET',
      url: '/api/crm-service/common/agency-staff-user-id',
      params: { agencyId: AgencyId, tenantId: TenantId },
    },
    { apiName: this.apiName,...config });
  

  getAgentIdByLeadByLeadId = (LeadId: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, number>({
      method: 'GET',
      url: `/api/crm-service/common/agent-id-by-lead/${LeadId}`,
    },
    { apiName: this.apiName,...config });
  

  getAgentIdByLeadByLeadIdAndTenantId = (LeadId: number, TenantId: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, number>({
      method: 'GET',
      url: '/api/crm-service/common/agent-id-by-lead',
      params: { leadId: LeadId, tenantId: TenantId },
    },
    { apiName: this.apiName,...config });
  

  getDetailsFromPhoneByPhoneNumber = (phoneNumber: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, GetCrmPhoneDetailDto>({
      method: 'GET',
      url: '/api/crm-service/common/details-from-phone',
      params: { phoneNumber },
    },
    { apiName: this.apiName,...config });
  

  getDropdownByDropdownType = (dropdownType: DropdownType, config?: Partial<Rest.Config>) =>
    this.restService.request<any, DropdownDto[]>({
      method: 'GET',
      url: '/api/crm-service/common/dropdown',
      params: { dropdownType },
    },
    { apiName: this.apiName,...config });
  

  getEntityIdAndEntityType = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, EntityIdAndEntityTypeDto>({
      method: 'GET',
      url: '/api/crm-service/common/entity-id-and-entity-type',
    },
    { apiName: this.apiName,...config });
  

  getMainAgencyIdByClaimNameByClaimName = (claimName: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, number>({
      method: 'GET',
      url: '/api/crm-service/common/main-agency-id-by-claim-name',
      params: { claimName },
    },
    { apiName: this.apiName,...config });
  

  getMainAgencyUserIdByClaimName = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, string>({
      method: 'GET',
      responseType: 'text',
      url: '/api/crm-service/common/main-agency-user-id-by-claim-name',
    },
    { apiName: this.apiName,...config });
  

  getPageMasterAndTourByRouterNameAndProjectType = (RouterName: string, ProjectType: ProjectType, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PageMasterDTO>({
      method: 'GET',
      url: '/api/crm-service/common/page-master-and-tour',
      params: { routerName: RouterName, projectType: ProjectType },
    },
    { apiName: this.apiName,...config });
  

  getcarrier = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, CarrierCachingDto[]>({
      method: 'GET',
      url: '/api/crm-service/common/carrier',
    },
    { apiName: this.apiName,...config });
  

  getconvertToUserTimeZoneByDateTimeAndUserId = (dateTime: string, UserId: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, string>({
      method: 'GET',
      responseType: 'text',
      url: `/api/crm-service/common/convert-to-user-time-zone/${UserId}`,
      params: { dateTime },
    },
    { apiName: this.apiName,...config });
  

  sendApiRequest = (serviceName: string, endpoint: string, method: any, requestBody?: object, queryParams?: Record<string, string>, config?: Partial<Rest.Config>) =>
    this.restService.request<any, string>({
      method: 'POST',
      responseType: 'text',
      url: '/api/crm-service/common/send-api-request',
      params: { serviceName, endpoint },
      body: queryParams,
    },
    { apiName: this.apiName,...config });
  

  sendSignDocumentEmailByInput = (input: SignDocumentEmailDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, string>({
      method: 'POST',
      responseType: 'text',
      url: '/api/crm-service/common/send-sign-document-email',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  sendSignEmailByInput = (input: SignDocumentEmailDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, boolean>({
      method: 'POST',
      url: '/api/crm-service/common/send-sign-email',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  sendWorkflowSignal = (workflowInstanceId: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, boolean>({
      method: 'POST',
      url: `/api/crm-service/common/send-workflow-signal/${workflowInstanceId}`,
    },
    { apiName: this.apiName,...config });

  constructor(private restService: RestService) {}
}
